import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';
import { createBenefitsRequest } from '../../requests/benefits';
import { sendAlert } from '../../actions/utils';
import benefit from './benefit';
import BenefitForm from './BenefitForm';

const BenefitNew = ({ setOnRequest, moreData, setMoreData }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSuccessCreate = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Beneficio creado con éxito' }));
    history.push('/benefits');
  };

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleCreateRequest = (benefitValues, setSubmitting) => {
    if (setOnRequest) setOnRequest(true);
    const { benefitsImage, attachedFile } = benefitValues.benefit;
    const myParams = snakeCaseKeys(benefitValues);
    myParams.benefit.image = benefitsImage;
    myParams.benefit.attached_file = attachedFile;

    createBenefitsRequest({
      dispatch,
      params: myParams,
      formData: true,
      successCallback: handleSuccessCreate,
      failureCallback: error => {
        setSubmitting(false);
        handleFailureRequest(error);
      },
      callback: () => {
        if (setOnRequest) setOnRequest(false);
        if (setMoreData) setMoreData(!moreData);
      }
    });
  };

  return <BenefitForm benefit={benefit} action="new" formRequest={handleCreateRequest} />;
};

export default BenefitNew;
